import { MutationTree } from "vuex";
import {
  FavoritesState,
  FavoriteRecipeClips,
  FavoriteFolderClips,
  FavoriteHistoryRecipes,
  FavoriteSendedHistoryRecipes,
  FavoriteFolderOperationResult,
  FavoriteOperationResult,
  FavoriteFolders
} from "@/types/favorites";
import NativeClient from "@/client/native-client";

const mutations: MutationTree<FavoritesState> = {
  updateAddRecipe: async (state, result: FavoriteOperationResult | null) => {
    state.addRecipeResult = result;
  },
  updateDeleteRecipe: (state, result: FavoriteOperationResult | null) => {
    state.deleteRecipeResult = result;
  },
  updateRecentMyList: (state, clips: FavoriteRecipeClips | null) => {
    state.recentMylist = clips;
  },
  updateMyList: (state, clips: FavoriteRecipeClips | null) => {
    if (clips == null) {
      // クリア
      NativeClient.sendDebugLog("Mutations.ts updateMyList clear");
      state.mylist = null;
    } else if (state.mylist == null) {
      // 元のデータなし
      NativeClient.sendDebugLog("Mutations.ts updateMyList initial");
      state.mylist = clips;
    } else {
      // 追加
      NativeClient.sendDebugLog("Mutations.ts updateMyList append");
      const mergedClips = state.mylist.clips.concat(clips.clips);
      const newClips: FavoriteRecipeClips = {
        ...clips,
        clips: mergedClips
      };
      state.mylist = newClips;
    }
  },
  updateFolderList: (state, folders: FavoriteFolders | null) => {
    state.folderList = folders;
  },
  updateRegistFolder: (state, result: FavoriteFolderOperationResult | null) => {
    state.registFolderResult = result;
  },
  updateFolderRecipeList: (state, clips: FavoriteFolderClips | null) => {
    if (clips == null) {
      // クリア
      state.folderRecipeList = null;
    } else if (state.folderRecipeList == null) {
      // 元のデータなし
      state.folderRecipeList = clips;
    } else {
      // 追加
      const mergedClips = state.folderRecipeList.clips.concat(clips.clips);
      const newClips: FavoriteFolderClips = {
        ...clips,
        clips: mergedClips
      };
      state.folderRecipeList = newClips;
    }
  },
  updateRenameFolder: (state, result: FavoriteFolderOperationResult | null) => {
    state.renameFolderResult = result;
  },
  updateDeleteFolder: (state, result: FavoriteFolderOperationResult | null) => {
    state.deleteFolderResult = result;
  },
  updateAddFolderRecipe: (state, result: FavoriteFolderOperationResult | null) => {
    state.addFolderRecipeResult
  },
  updateDeleteFolderRecipe: (state, result: FavoriteOperationResult | null) => {
    state.deleteFolderRecipeResult = result;
  },
  updateMoveFolder: (state, result: FavoriteOperationResult | null) => {
    state.folderMoveResult = result;
  },
  updateFolderName: (state, folderName: string | null) => {
    state.folderName = folderName;
  },
  updateSendedHistory: (state, recipes: FavoriteSendedHistoryRecipes | null) => {
    if (recipes == null) {
      // クリア
      NativeClient.sendDebugLog("Mutations.ts updateSendedHistory clear");
      state.sendedHistory = null;
    } else if (state.sendedHistory == null) {
      // 元のデータなし
      NativeClient.sendDebugLog("Mutations.ts updateSendedHistory initial");
      state.sendedHistory = recipes;
    } else {
      // 追加
      NativeClient.sendDebugLog("Mutations.ts updateSendedHistory append");
      const mergedRecipes = state.sendedHistory.recipes.concat(recipes.recipes);
      const newRecipes: FavoriteSendedHistoryRecipes = {
        ...recipes,
        recipes: mergedRecipes
      };
      state.sendedHistory = newRecipes;
    }
  },
  updateViewedHistory: (state, recipes: FavoriteHistoryRecipes | null) => {
    if (recipes == null) {
      // クリア
      NativeClient.sendDebugLog("Mutations.ts updateViewedHistory clear");
      state.viewedHistory = null;
    } else if (state.viewedHistory == null) {
      // 元のデータなし
      NativeClient.sendDebugLog("Mutations.ts updateViewedHistory initial");
      state.viewedHistory = recipes;
    } else {
      // 追加
      NativeClient.sendDebugLog("Mutations.ts updateViewedHistory append");
      const mergedRecipes = state.viewedHistory.recipes.concat(recipes.recipes);
      const newRecipes: FavoriteHistoryRecipes = {
        ...recipes,
        recipes: mergedRecipes
      };
      state.viewedHistory = newRecipes;
    }
  },
  updateSelectedTab: (state, selected: number) => {
    NativeClient.sendDebugLog("Mutations.ts updateDisplayTab");
    state.selectedTab = selected;
  }
};

export default mutations;
